import React, { useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import { AppService } from '../common/AppService'
import Autosave from './Autosave';
import FormButtons from './FormButtons';
import FormContent from './FormContent';
import './FormPage.scss';
import FormSteps from './FormSteps';
import initialValues from './initialValues';

import schema from './schema';
import { defaultSteps, getStep } from '../steps';
import StepSelect from './StepSelect';
import TallyErrors from './TallyErrors';
import TouchStepFields from './TouchStepFields';

const requiredFields: { [key:string]: boolean } = {};
Object.keys(initialValues).forEach(name => {
  try {
    schema.validateSyncAt(name, initialValues);
  } catch (validationError) {
    if (validationError.errors.some((error: string) => /required/.test(error))) {
      requiredFields[name] = true;
    }
  }
});

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      overflowX: 'scroll',
    },
  },
}));

const validateFormData = (formData: any) => {
  // Get all the keys from initialValues
  const initialKeys = Object.keys(initialValues);

  // Check if each key exists in formData
  for (let key of initialKeys) {
    if (!(key in formData)) {
      return false;
    }
  }

  // If we made it through the loop without returning, all keys exist
  return true;
};


const FormPage = (props: any) => {
    
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [dueDiligence, setDueDiligence] = useState({});

  React.useEffect(() => {
      window.scrollTo(0, 0);

      const storedUser: any = localStorage.getItem('Alutiiq-PreQualificationPortal/user');
      if (storedUser) {
          const user = JSON.parse(storedUser);
          if (user && user.email) { 
                  const appService = new AppService();
                  appService.saveUser(user.email, user.isGuest).then((response: any) => {
                      if (response.data.errors && response.data.errors.length) {
                          console.log(response.data.errors);
                      }

                    if (user.isGuest) {
                        // If the user is a guest, get the form data from local storage if it exists
                        const storedFormData: any = localStorage.getItem('Alutiiq-PreQualificationPortal/formData');
                        if (storedFormData) {
                            const formData = JSON.parse(storedFormData);
                        // Validate the formData
                            if (validateFormData(formData)) {
                              setDueDiligence(formData);
                            } else {
                              setDueDiligence(initialValues);
                            }
                          } else {
                            setDueDiligence(initialValues);
                          }
                    } else {
                        // If the user is not a guest, get the due diligence data from the API
                        return appService.getDueDiligence(user.email).then((response: any) => {
                            if (response.data && response.data.dueDiligence) {
                                setDueDiligence(response.data.dueDiligence);
                            }
                        }).catch((error: any) => console.log(error));
                    }
                  }).then((response: any) => {}) 
                    .catch((error: any) => console.log(error));
              }
          }
  }, []);

  const steps = defaultSteps;
  const step = getStep(steps, location.pathname);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <nav className="navbar is-dark">
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <img src="/alutiiq-logo.png" alt="Alutiiq logo" />
          </a>
          <h1 className="navbar-item title is-4 is-hidden-mobile">
              Afognak Registration Portal
          </h1>
              </div>
          <div style={{ display: 'block', float: 'right' }}>
                  <a onClick={() => props.logoutFunction() }> 
                      <h1 className="navbar-item title is-4 is-hidden-mobile" style={{color: 'white'}}>
                     Logout
                  </h1></a>
          </div>
      </nav>
      <div className={classes.root} style={{ display: 'flex', flex: 'auto' }}>
        <div className="is-hidden-mobile" style={{ background: '#fff', minWidth: '335px', padding: '2rem', width: '335px' }}>
          <div style={{ position: 'sticky', top: '2rem' }}>
            <FormSteps step={step} steps={steps} />
          </div>
        </div>
        <div className="has-background-light FormContainer">
          <Formik
            initialValues={dueDiligence || initialValues}
                      enableReinitialize={true}
                      onSubmit={() => {}}
                      validateOnMount={true}
                      validateOnChange={true}
                      isInitialValid={false}
            validationSchema={schema}
          >
            {({ isSubmitting, isValid }) => {
              return (
                <Form style={{ flex: 'auto' }}>
                  <div className="has-background-white" style={{ padding: '2rem', display: 'flex', flexDirection: 'column' }}>
                    <div className="is-hidden-tablet" style={{ display: 'flex', justifyContent: 'space-around', paddingBottom: '2rem' }}>
                      <div>
                        <StepSelect steps={steps} value={step} />
                      </div>
                    </div>
                    <div style={{ flex: 'auto' }}>
                      <Autosave />
                      <FormContent steps={steps} />
                      <TallyErrors />
                      <TouchStepFields step={step} />
                    </div>
                    <FormButtons isSubmitting={isSubmitting} isValid={isValid} step={step} steps={steps} />
                  </div>
                </Form>
              );
            }}
          </Formik>
          <div className="has-background-light is-size-7" style={{ padding: '1.5rem', textAlign: 'center' }}>
            If you have questions about this application or its processing, please contact the Alutiiq Due Diligence Team at <a href="mailto:duediligence@alutiiq.com">DueDiligence@alutiiq.com</a> | <a href="https://privacy.afognak.com/" target="_blank">Privacy Statement</a> | <a href="https://privacy.afognak.com/california-consumer-privacy-act-ccpa-notice-at-collection/" target="_blank">CCPA Collection Notice</a> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormPage;

export { requiredFields };
